/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as JoinRouteImport } from './routes/join'
import { Route as PlayRouteImport } from './routes/play'
import { Route as LobbyRoomIdRouteImport } from './routes/lobby.$roomId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayRoute = PlayRouteImport.update({
  id: '/play',
  path: '/play',
  getParentRoute: () => rootRouteImport,
} as any)
const LobbyRoomIdRoute = LobbyRoomIdRouteImport.update({
  id: '/lobby/$roomId',
  path: '/lobby/$roomId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/join': typeof JoinRoute
  '/play': typeof PlayRoute
  '/lobby/$roomId': typeof LobbyRoomIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/join': typeof JoinRoute
  '/play': typeof PlayRoute
  '/lobby/$roomId': typeof LobbyRoomIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/join': typeof JoinRoute
  '/play': typeof PlayRoute
  '/lobby/$roomId': typeof LobbyRoomIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/join' | '/play' | '/lobby/$roomId'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/join' | '/play' | '/lobby/$roomId'
  id: '__root__' | '/' | '/join' | '/play' | '/lobby/$roomId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  JoinRoute: typeof JoinRoute
  PlayRoute: typeof PlayRoute
  LobbyRoomIdRoute: typeof LobbyRoomIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/play': {
      id: '/play'
      path: '/play'
      fullPath: '/play'
      preLoaderRoute: typeof PlayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lobby/$roomId': {
      id: '/lobby/$roomId'
      path: '/lobby/$roomId'
      fullPath: '/lobby/$roomId'
      preLoaderRoute: typeof LobbyRoomIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  JoinRoute: JoinRoute,
  PlayRoute: PlayRoute,
  LobbyRoomIdRoute: LobbyRoomIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
